import { render } from "./IconHandleVertical.vue?vue&type=template&id=170278a6"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconHandleVertical.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "170278a6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('170278a6', __exports__)) {
    api.reload('170278a6', __exports__)
  }
  
  module.hot.accept("./IconHandleVertical.vue?vue&type=template&id=170278a6", () => {
    api.rerender('170278a6', render)
  })

}


export default __exports__